// Table temporarily hidden while the balance overview above is being reworked (task #88)
// import { AffiliateRequestPayoutsTable } from "components/Tables/AffiliateRequestPayoutsTable/AffiliateRequestPayoutsTable.tsx";
import { AffiliateBalanceTotals } from "components/UI/AffiliateBalanceTotals/AffiliateBalanceTotals.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { useUser } from "hooks/useUser.ts";
import { PermissionEnum, RoleEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getAffiliateHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/payout/")({
    component: AffiliatePayoutRequestsPage,
    staticData: {
        permissions: [PermissionEnum.AffiliatePayoutView],
        showInSideMenu: false,
        label: "pages.affiliate.request.payout.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.affiliate.request.payout.title"),
        };
    },
});

function AffiliatePayoutRequestsPage() {
    const userUtils = useUser();

    return (
        <TenantPage headerNavigationItems={getAffiliateHeaderItems}>
            {userUtils
                .getActiveTenant()
                ?.userRoles?.some((role) => [RoleEnum.AffiliatePartner].includes(role.name)) && (
                <SectionContentWrapper className={"bg-white p-5 rounded-md mb-5"}>
                    <AffiliateBalanceTotals />
                </SectionContentWrapper>
            )}
            {/* Temporarily hidden while the balance overview above is being reworked (task #88) */}
            {/* <SectionContentWrapper className={"bg-white p-5 rounded-md"}>
                <AffiliateRequestPayoutsTable
                    onApprove={() => {
                        getBalancesQuery.refetch();
                    }}
                />
            </SectionContentWrapper> */}
        </TenantPage>
    );
}
